﻿import { Api } from 'pages/orders/fulfillment_manager/Api';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { Fulfillment } from 'types';
import { useApp } from 'app';

import 'pages/orders/fulfillment_manager/components/FulfillmentLookup/styles/FulfillmentLookup.scss';

interface FulfillmentLookupProps {
    fulfillments: Fulfillment[];
    onFulfillmentClick: (fulfillment: Fulfillment) => void;
    setFulfillments: (fulfillments: Fulfillment[]) => void;
}

export const FulfillmentLookup = (props: FulfillmentLookupProps) => {

    const { fulfillments, onFulfillmentClick, setFulfillments } = props;

    const [state, setState] = useSuperState({
        lastSearchTerm: undefined as string | undefined,
        loading: false,
        searchTerm: ''
    });
    const { lastSearchTerm, loading, searchTerm } = state;

    const { userId } = useApp();
    const { formatMessage } = useIntl();

    const onSearchButtonClick = async () => {

        setState({ loading: true });
        try {

            const fulfillments = await Api.GetFulfillments(userId, searchTerm);
            setFulfillments(fulfillments);
            setState({ lastSearchTerm: searchTerm, loading: false });

        } catch (error) {

            console.error('Failed to search fulfillments:', error);
            setState({ loading: false });

        }

    };

    return (
        <div className="card card-body">
            <div className="d-flex flex-wrap gap-2 align-items-end mb-3">
                <div className="flex-grow-1">
                    <label className="form-label" htmlFor="searchInput">

                        <FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />
                    </label>
                    <input
                        className="form-control"
                        id="searchInput"
                        onChange={e => setState({ searchTerm: e.target.value })}
                        placeholder={formatMessage({ id: 'search_code_type_or_description.443ad2de', defaultMessage: 'Search code, type, or description...' })}
                        type="text"
                        value={searchTerm}
                    />
                </div>
                <div className="d-flex gap-2">
                    <Button
                        onClick={e => {

                            e.preventDefault();
                            onSearchButtonClick();

                        }}
                        variant="outline-primary"
                    >
                        <FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />
                    </Button>
                </div>
            </div>

            <div className="table-responsive">
                <table className="table border">
                    <thead>
                        <tr>
                            <th>
                                <FormattedMessage defaultMessage="Code" id="code.cc651d9c" />
                            </th>
                            <th>
                                <FormattedMessage defaultMessage="Type" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="type.a129b9e6" />
                            </th>
                            <th>
                                <FormattedMessage defaultMessage="Description" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="description.6317db73" />
                            </th>
                            <th>
                                <FormattedMessage defaultMessage="Number of Items" id="number_of_items.f89336d5" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ?
                            (
                                <tr>
                                    <td className="text-center py-4" colSpan={5}>
                                        <div className="spinner-border text-primary" role="status" />
                                    </td>
                                </tr>
                            )
                            : fulfillments.length > 0 ?
                                (
                                    fulfillments.map(fulfillment => (
                                        <tr key={fulfillment.ExternalId} onClick={() => onFulfillmentClick(fulfillment)} style={{ cursor: 'pointer' }}>
                                            <td>
                                                {fulfillment.Code}
                                            </td>
                                            <td>
                                                {fulfillment.DeliverableTypeName}
                                            </td>
                                            <td>
                                                {fulfillment.Description}
                                            </td>
                                            <td>
                                                {fulfillment.Count}
                                            </td>
                                        </tr>
                                    ))
                                )
                                :
                                (
                                    <tr>
                                        <td className="text-center text-muted py-4" colSpan={5}>
                                            <i className="fa-solid fa-search fa-3x mb-2 d-block" />
                                            <div>
                                                {lastSearchTerm !== undefined
                                                    ? formatMessage({ id: 'no_search_results_found_for_the_search_t.3866ec30', defaultMessage: 'No search results found for the search term "{terminput}".' }, { terminput: lastSearchTerm })
                                                    : <FormattedMessage defaultMessage="Enter a search keyword above to find fulfillment codes." id="enter_a_search_keyword_above_to_find_ful.793f7073" />}
                                            </div>
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>
        </div>

    );

};